<div class="stop-marker__badge" [style.background]="color">
    <i *ngIf="isUnassigned; else stopLabel" class="fa fa-map-marker" aria-hidden="true"></i>
    <ng-template #stopLabel>
        {{ stopNumber }}
        {{
            (isPickup ? "delivery-plan-viewer.stop-badge-pickup" : "delivery-plan-viewer.stop-badge-delivery")
                | translate
        }}
    </ng-template>
</div>
<div class="stop-marker__code">{{ orderCode }}</div>
<div *ngIf="eta" class="stop-marker__eta">{{ "delivery-plan-viewer.eta" | translate: { time: eta } }}</div>